// removed by extract-text-webpack-plugin
module.exports = {"pageHome":"_1khK9MNTGYPNn4rkshH_tL","hero":"_1OP15k4sEYAkaZ_PiX7Qz8","ketakaLogo":"_1jt0OwIttbDc6Mkpipvjqi","intro":"_3s8sIAlWbcFLmklJNAseuF","formSearch":"_1KqWCJc9eqKnj7N_OGoSmE","appListContainer":"zgem8ZkMyw97cMkIKCR3T","appList":"_3CJoph4fIo0HtndpkQ2lu","list":"_2ZukyrNW5c2MeUVE5Kdp-u","app":"_1S95NidxWghbEd9bfNWSOj","titleBlock":"_1G5ORyOcFN4yQWn0dUUqFY","appTitle":"_1jNicw0CgXJY4RMJ9Iqlnk","descBlock":"OUtfBm1aqRvyaRgvDu944","detail":"_15R_bGTGsYb7FkacVQkP83","grid":"_1NuNsQ0nT2oWR8Q_BMMeov","desc":"_11yE_eWH9aaTsM3qYujxj8","appToolbar":"_32WeGVn7yxHJuvOMUL4qjQ","toolbar":"_1Ar3xhpQdVMdAJTahvlaFp","pipe":"_1kAhKsDiqcg1h3bwyQsxjk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PageHome/PageHome.scss
 ** module id = 815
 ** module chunks = 0
 **/